import './styles.scss'

export const Conclusion = () => {
  return (
    <div className="container-conclusion-root">
      <div className="content-title">
        <strong>Concluído!</strong>

        <p>Tudo pronto.</p>
        <p>
          Recebemos as suas configurações e estamos preparando tudo para você.
        </p>
      </div>
    </div>
  )
}
